import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const VacancyListSkeleton = (props) => {
    const tempArray = [];
    for (let i = 0; i < props.count; i++) {
        tempArray[i] = i;
    }
    {
        return (
            tempArray.map((q, index) => (
                <div key={index} className="join-invite-list">
                    <div className="join-invite-user">
                        <div className="join-invite-content pl-2 rounded-left" style={{ borderLeft: "3px solid #e9e9e9" }}>
                            <Skeleton width={400} />
                            <Skeleton width={500} />
                            <Skeleton width={350} />
                        </div>
                    </div>
                    <div className="join-invite-action">
                        <Skeleton inline={true} count={2} width={100} height={40} borderRadius={50} className="mr-1" />
                    </div>
                </div>
            ))
        );
    }
}

export default VacancyListSkeleton;